"use strict";

exports["default"] = function (obj) {
  return obj && obj.__esModule ? obj["default"] : obj;
};

exports.__esModule = true;


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/helpers/interop-require.js
// module id = 1204
// module chunks = 0